export enum ModalDocumentVerificationFormControlName {
  DocumentId = 'documentId'
}
